export const hasRefusalReason = (featureFlag: boolean, hasReason: boolean) => {
  if (featureFlag && hasReason) {
    return true;
  }
  return false;
};

export const hasFaceVerified = (
  featureFlag: boolean,
  hasVerifiedLiveness: boolean,
) => {
  if (featureFlag && hasVerifiedLiveness) {
    return true;
  }
  return false;
};
